import PropTypes from "prop-types";
import { Avatar, Empty, Spin } from "antd";
import { HiDotsHorizontal } from "react-icons/hi";
import cn from "../../../utilities/tailwind-merge";
import { RowActionsMenu } from "../../../components/data-table";

const getInitials = (user) => {
    const first = user?.firstName?.[0] || "";
    const last = user?.lastName?.[0] || "";
    const combined = `${first}${last}`.trim();
    if (combined) return combined.toUpperCase();
    return user?.email?.[0]?.toUpperCase() || "?";
};

const MobileCustomerListItem = ({ user, actionItems, onActionClick, t }) => {
    const displayName =
        [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim() ||
        user?.name ||
        t("common.notAvailable");

    return (
        <div className="flex items-center gap-3 py-3">
            <Avatar src={user?.userImage || undefined} size={48} className="!shrink-0 bg-[#EEF0F6] text-[#5D5DF6]">
                {getInitials(user)}
            </Avatar>

            <div className="min-w-0 flex-1">
                <p className="truncate text-base font-semibold text-[#2F2F46]">{displayName}</p>
                <p className="truncate text-sm text-[#667085]">{user?.email || t("common.notAvailable")}</p>
            </div>

            <RowActionsMenu
                items={actionItems}
                onClick={({ key }) => onActionClick(key, user)}
                label={t("action")}
                icon={<HiDotsHorizontal className="text-lg" />}
                className="!h-9 !w-9 shrink-0 !rounded-full text-[#667085]"
            />
        </div>
    );
};

MobileCustomerListItem.propTypes = {
    user: PropTypes.object.isRequired,
    actionItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    onActionClick: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

function CustomerListCards({ customers, loading, actionItems, onActionClick, t }) {
    if (loading && customers.length === 0) {
        return (
            <div className="flex min-h-[200px] items-center justify-center">
                <Spin />
            </div>
        );
    }

    if (!loading && customers.length === 0) {
        return (
            <div className="py-10">
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
        );
    }

    return (
        <div className="relative min-h-[120px]">
            {loading ? (
                <div
                    className="absolute inset-0 z-10 flex items-center justify-center rounded-xl bg-white/70"
                    aria-busy="true"
                    aria-live="polite">
                    <Spin />
                </div>
            ) : null}
            <div
                className={cn("flex flex-col", loading && "pointer-events-none select-none opacity-50")}
                aria-hidden={loading}>
                {customers.map((user, index) => (
                    <div
                        key={user.id}
                        className={index < customers.length - 1 ? "border-b border-[#E5E7EB]" : undefined}>
                        <MobileCustomerListItem
                            user={user}
                            actionItems={actionItems}
                            onActionClick={onActionClick}
                            t={t}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

CustomerListCards.propTypes = {
    customers: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool.isRequired,
    actionItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    onActionClick: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default CustomerListCards;
